import { render, staticRenderFns } from "./BranchUsersModal.vue?vue&type=template&id=0c02ca49&scoped=true&"
import script from "./BranchUsersModal.vue?vue&type=script&lang=js&"
export * from "./BranchUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02ca49",
  null
  
)

export default component.exports